export const DIS = 'DIS'
export const _84 = '84'
export const _90 = '90'
export const _95 = '95'
export const _97 = '97'
export const GLP = 'GLP'

export const __dictionary = {
  [DIS]: {
    id: DIS,
    nombre: 'BIO DIESEL'
  },
  [_84]: {
    id: _84,
    nombre: 'GASOLINA 84'
  },
  [_90]: {
    id: _90,
    nombre: 'GASOLINA 90'
  },
  [_95]: {
    id: _95,
    nombre: 'GASOLINA 95'
  },
  [_97]: {
    id: _97,
    nombre: 'GASOLINA 97'
  },
  [GLP]: {
    id: GLP,
    nombre: 'GAS GLP'
  }
}

export const __array = [
  __dictionary[DIS],
  __dictionary[_84],
  __dictionary[_90],
  __dictionary[_95],
  __dictionary[_97],
  __dictionary[GLP]
]
